import React, { useState } from 'react';
import './QuickHelpSection.scss';
import CreateTicketModal from '@/components/tenant/Tickets/CreateTicketModal';
import UIIconButton from '@/components/shared/UIIconButton';

interface QuickHelpBlockProps {
  categories: string[];
  onTicketCreated: () => void;
  dictionarySource: 'home' | 'tickets';
}

const formatCategoryLabel = (categoryId: string) => {
  return categoryId.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
};

const QuickHelpSection: React.FC<QuickHelpBlockProps> = ({
  categories,
  onTicketCreated,
  dictionarySource,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = () => {
    if (searchQuery.trim()) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSearchQuery('');
    setSelectedCategory(null);
  };

  const handleCategoryClick = (category: string) => {
    if (selectedCategory === category) {
      setSelectedCategory(null); // Deselect if clicked again
    } else {
      setSelectedCategory(category);
    }
  };

  return (
    <>
      <div className="quickHelpBlock">
        <div className="quickHelpBlock__form">
          <div className="quickHelpBlock__inputGroup">
            <input
              type="text"
              className="quickHelpBlock__input"
              placeholder="How can we help you?"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
            />
            <UIIconButton
              iconType="go"
              variant="info"
              size="medium"
              onClick={handleSubmit}
              disabled={!searchQuery.trim()}
            />
          </div>
        </div>
        <div className="quickHelpBlock__suggestions">
          {(categories || []).map((category) => (
            <button
              key={category}
              className={`quickHelpBlock__category ${
                selectedCategory === category ? 'quickHelpBlock__category--selected' : ''
              }`}
              onClick={() => handleCategoryClick(category)}
            >
              <span className="quickHelpBlock__categoryLabel">
                {formatCategoryLabel(category)}
              </span>
            </button>
          ))}
        </div>
      </div>
      <CreateTicketModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        initialQuery={searchQuery}
        initialCategory={selectedCategory || undefined}
        onTicketCreated={onTicketCreated}
        dictionarySource={dictionarySource}
      />
    </>
  );
};

export default QuickHelpSection;
